import { render, staticRenderFns } from "./TeamsView.vue?vue&type=template&id=0c00a139"
import script from "./TeamsView.vue?vue&type=script&lang=js"
export * from "./TeamsView.vue?vue&type=script&lang=js"
import style0 from "./TeamsView.vue?vue&type=style&index=0&id=0c00a139&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports